<!--
 * @Description: 菜单图标组件 - 支持SVG图标和Element Plus图标
-->
<template>
  <!-- Element Plus 图标 -->
  <el-icon v-if="isElementIcon" class="menu-icon">
    <component :is="elementIconName" />
  </el-icon>
  <!-- SVG 图标 -->
  <svg-icon v-else :icon-class="icon" class="menu-icon" />
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue'

const props = defineProps({
  icon: {
    type: String,
    default: ''
  }
})

const instance = getCurrentInstance()

// 判断是否为Element Plus图标
const isElementIcon = computed(() => {
  if (!props.icon) return false

  // 检查图标是否为Element Plus图标（通过检查是否为已注册的全局组件）
  const app = instance?.appContext.app
  if (app && app.component(props.icon)) {
    return true
  }

  // 备用检查：Element Plus图标通常以大写字母开头
  return /^[A-Z][a-zA-Z]*$/.test(props.icon)
})

// Element Plus图标名称
const elementIconName = computed(() => {
  return isElementIcon.value ? props.icon : ''
})
</script>

<style scoped>
.menu-icon {
  margin-right: 16px;
  width: 1em;
  height: 1em;
  vertical-align: -2px;
}
</style>
